/* This file was generated automatically. Do not edit manually. */

export enum TransactionHistoryItemType {
    Other = 'Other',
    MewsPaymentCommissionChargeback = 'MewsPaymentCommissionChargeback',
    MewsPaymentCommissionChargebackReversal = 'MewsPaymentCommissionChargebackReversal',
    MewsPaymentCommissionRefund = 'MewsPaymentCommissionRefund',
    MewsPaymentCommission = 'MewsPaymentCommission',
    Refund = 'Refund',
    PartialRefund = 'PartialRefund',
    GrossAmount = 'GrossAmount',
    Chargeback = 'Chargeback',
    ChargebackReversal = 'ChargebackReversal',
    PositiveCommissionAdjustment = 'PositiveCommissionAdjustment',
    NegativeCommissionAdjustment = 'NegativeCommissionAdjustment',
}
